module.exports = __webpack_public_path__ + "static/media/spotify.a569c7d5.svg";